/**
 * @generated SignedSource<<033bf92ccead86d6a3cb07bd580235ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type StoreTier = "basic" | "free" | "light" | "premium" | "standard" | "unlimited";
export type UserFlag = "FinishedSetup" | "NoteIntroduction" | "RoutineIntroduction" | "TodoIntroduction";
import { FragmentRefs } from "relay-runtime";
export type UserLoggedInQuery_query$data = {
  readonly currentStore: {
    readonly myRole: Roles;
    readonly name: string;
    readonly tier: StoreTier;
  } | null;
  readonly home: {
    readonly __typename: "Organisation";
    readonly id: string;
  } | {
    readonly __typename: "Store";
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly me: {
    readonly flags: ReadonlyArray<UserFlag>;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "UserLoggedInQuery_query";
};
export type UserLoggedInQuery_query$key = {
  readonly " $data"?: UserLoggedInQuery_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserLoggedInQuery_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserLoggedInQuery_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flags",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "currentStore",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "myRole",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "home",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timezone",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "type": "Store",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "type": "Organisation",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e25f4ac66df6125bc6436c43571e8cdc";

export default node;
